import React from 'react';
import { func, number, oneOfType, shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { useCheckAuthorityType } from '../../../../../hooks/useCheckUser';
import DefaultViewNoImage from '../atoms/noImageView/NoImageView';
import Favorites from '../atoms/favorites/Favorites';
import GreenLeafTag from '../../../atoms/greenLeafTag/GreenLeafTag';
import { productTileDataLocator } from '../../addToCartTile/dataLocators';
import { formatCatClass } from '../../../utils/commonUtils';
import { DOTCOM, IMAGE_HEIGHT, P2P } from '../constants';
import FavouritesButton from '../../../../favorites/modules/favouritesButton/FavouritesButton';
import { AUTHORITY_TYPE, PRODUCT_TILE_VARIANT } from '../../../constants';
import ProductTileListView from '../productTileListView/ProductTileListView';


const Unavailable = ({ tileDetails, accountNumber, handleAnchorClick, handleRedirectClick, variant }) => {
    const intl = useIntl();
    const authorityType = useCheckAuthorityType();
    const isP2P = authorityType === AUTHORITY_TYPE.P2P;
    const isGreenLeaf = tileDetails?.isgreenleaf;
    return (
        variant === PRODUCT_TILE_VARIANT.LIST_VIEW ?
            <div className='producttile list-view__unavailable'>
                <ProductTileListView
                    catClass={tileDetails?.catclass}
                    accountNumber={accountNumber}
                    productName={tileDetails?.producttitle}
                    productImg={tileDetails?.productimageurl}
                    handleRedirectClick={handleRedirectClick}
                    productUrl={tileDetails?.producturl}
                    handleAnchorClick={handleAnchorClick}
                    specifications={tileDetails?.specifications}
                    isUnavailable={true}
                    greenLeafDetails={{ isGreenLeaf: isGreenLeaf, greenLeafData: tileDetails?.greenleafdata }}
                />
            </div>:
        <div className="producttile">
            <div
                data-testid={productTileDataLocator.productTile_productFavoriteIndicator}
                className="producttile__favourite">
                {!isP2P && (
                    <Favorites
                        sku={tileDetails?.catclass}
                        accountNumber={accountNumber}
                        showFavoriteTitle={false}
                        productName={tileDetails?.producttitle}
                    />
                )}
            </div>
            <a
                className="producttile__top"
                href={tileDetails?.producturl}
                onClick={handleAnchorClick}
                aria-label={`${intl.formatMessage({ id: 'product-tile-unavailable' })} ${intl.formatMessage({ id: 'common:for' })} ${tileDetails?.producttitle}`}>
                {tileDetails?.productimageurl ? (
                    <div className="producttile__img" onClick={handleRedirectClick}>
                        <img src={tileDetails?.productimageurl} alt={tileDetails?.producttitle} height={IMAGE_HEIGHT} className="unavailable-img" />
                        <div className="producttile__unavailable">
                            {intl.formatMessage({ id: 'product-tile-unavailable' })}
                        </div>
                    </div>
                ) : (
                    <div className="producttile__img-unavailable">
                        <DefaultViewNoImage />
                        <div className="producttile__unavailable">
                            {intl.formatMessage({ id: 'product-tile-unavailable' })}
                        </div>
                    </div>
                )}

                <div>
                    <h3 className="producttile__catclass eyebrow">{`${intl.formatMessage({
                        id: 'homepage:cat-class'
                    })} ${formatCatClass(tileDetails?.catclass)}`}</h3>
                    <h4
                        className={`producttile__productname ${
                            isGreenLeaf ? 'producttile__productname__green-leaf' : ''
                        }`}>
                        {tileDetails?.producttitle}
                    </h4>
                </div>
            </a>
            {isGreenLeaf && <GreenLeafTag greenLeafData={tileDetails?.greenleafdata} />}
            {isP2P && <FavouritesButton sku={tileDetails?.catclass} qty={1} productName={tileDetails?.producttitle} />}
        </div>
    );
};

export default React.memo(Unavailable);

Unavailable.defaultProps = {
    tileDetails: {
        catclass: '',
        producttitle: '',
        productimageurl: '',
        producturl: '#',
        showonlinecatalog: 'YES',
        disableaddtocartoption: 'NO',
        categoryname: '',
        catsku: '',
        catid: '',
        metaTitle: '',
        metaDescription: '',
        productAltText: ''
    },
    accountNumber: '',
    handleAnchorClick: () => {},
    handleRedirectClick: () => {}
};

Unavailable.propTypes = {
    tileDetails: shape({
        catclass: oneOfType([number, string]),
        producttitle: string,
        productimageurl: string,
        producturl: string,
        showonlinecatalog: string,
        disableaddtocartoption: string,
        categoryname: string,
        catsku: oneOfType([number, string]),
        catid: oneOfType([number, string]),
        metaDescription: string,
        metaTitle: string,
        productAltText: string
    }),
    accountNumber: string,
    handleAnchorClick: func,
    handleRedirectClick: func
};
